import React from "react";
import {Box, Button, Menu, MenuItem, Stack, Typography,} from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const options = [
    'None',
    'Atria',
    'Callisto',
    'Dione',
    'Ganymede',
    'Hangouts Call',
    'Luna',
    'Oberon',
    'Phobos',
    'Pyxis',
    'Sedna',
    'Titania',
    'Triton',
    'Umbriel',
];
const MAxHeightMenu = () => {
  const ITEM_HEIGHT = 32;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
      <Stack spacing={2} p={3}>
          <Box>
              <Typography variant={"h6"} color={"text.primary"}>
                  Max height menu
              </Typography>
              <Typography variant={"body2"} color={"text.primary"}>
                  If the height of a menu prevents all menu items from being displayed, the menu can scroll internally.
              </Typography>
          </Box>
          <Box sx={{ width: "80%", alignSelf: "center" }}>
      <PreviewAndEditor
        language="js"
        title={"Menu with auto width and max height"}
        value={"import {Box, Button, Menu, MenuItem,} from \"@mui/material\";"+
            "const options = [\n" +
            "    'None',\n" +
            "    'Atria',\n" +
            "    'Callisto',\n" +
            "    'Dione',\n" +
            "    'Ganymede',\n" +
            "    'Hangouts Call',\n" +
            "    'Luna',\n" +
            "    'Oberon',\n" +
            "    'Phobos',\n" +
            "    'Pyxis',\n" +
            "    'Sedna',\n" +
            "    'Titania',\n" +
            "    'Triton',\n" +
            "    'Umbriel',\n" +
            "];\n\n\n"+
            "const ITEM_HEIGHT = 32;\n" +
            "  const [anchorEl, setAnchorEl] = React.useState(null);\n" +
            "  const open = Boolean(anchorEl);\n" +
            "  const handleClick = (event) => {\n" +
            "    setAnchorEl(event.currentTarget);\n" +
            "  };\n" +
            "  const handleClose = () => {\n" +
            "    setAnchorEl(null);\n" +
            "  };\n\n\n"+
            "<Button\n" +
            "            id=\"basic-button\"\n" +
            "            aria-controls={open ? \"basic-menu\" : undefined}\n" +
            "            aria-haspopup=\"true\"\n" +
            "            aria-expanded={open ? \"true\" : undefined}\n" +
            "            onClick={handleClick}\n" +
            "        >\n" +
            "          Dashboard\n" +
            "        </Button>\n" +
            "        <Menu\n" +
            "            id=\"long-menu\"\n" +
            "            MenuListProps={{\n" +
            "                'aria-labelledby': 'long-button',\n" +
            "            }}\n" +
            "            anchorEl={anchorEl}\n" +
            "            open={open}\n" +
            "            onClose={handleClose}\n" +
            "            PaperProps={{\n" +
            "              style: {\n" +
            "                maxHeight: ITEM_HEIGHT * 4.5,\n" +
            "              },\n" +
            "            }}\n" +
            "        >\n" +
            "            {options.map((option) => (\n" +
            "                <MenuItem key={option} selected={option === 'Pyxis'} onClick={handleClose}>\n" +
            "                    {option}\n" +
            "                </MenuItem>\n" +
            "            ))}\n" +
            "     </Menu>"}
      >
        <Button
            id="basic-button"
            aria-controls={open ? "basic-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
        >
          Dashboard
        </Button>
        <Menu
            id="long-menu"
            MenuListProps={{
                'aria-labelledby': 'long-button',
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            PaperProps={{
              style: {
                maxHeight: ITEM_HEIGHT * 4.5,
              },
            }}
        >
            {options.map((option) => (
                <MenuItem key={option} selected={option === 'Pyxis'} onClick={handleClose}>
                    {option}
                </MenuItem>
            ))}
     </Menu>
      </PreviewAndEditor>
    </Box>
      </Stack>
  );
};

export default MAxHeightMenu;
